export default {
  path: 'notes-tasks',
  name: 'vendor/notes-tasks',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "vendor-show-notes-tasks" */ './NotesTasks')
}
